const phones = document.querySelectorAll('[data-format-phone]');

if (phones.length) {
  phones.forEach(item => {
    let textPhone = item.textContent.split('').filter(el => el.match(/[0-9]/g)).join('');

    item.setAttribute('href', `tel:+${textPhone}`);
  })
}